import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LoginService, UserData } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-iban-aggiuntivi',
  templateUrl: './iban-aggiuntivi.component.html',
  styleUrls: ['./iban-aggiuntivi.component.css']
})
export class IbanAggiuntiviComponent implements OnInit {

  public ibans : string[] = [];
  public loading: boolean = true;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private loginService: LoginService, private userService: UserService) { }

  async ngOnInit(){
    //let userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    if(userInfo!=undefined){
          let json_data = JSON.parse(userInfo.json_sdi_data);
          if(json_data.iban!='')
              this.ibans.push(json_data.iban);
          if(json_data.iban_aggiuntivi!=undefined)
              this.ibans=this.ibans.concat(json_data.iban_aggiuntivi);
    }
    this.loading=false;
  }


  close(){
    this.activeModal.close(null);
  }

  public save(index:number){
    this.activeModal.close(this.ibans[index]);
  }

}
